import apiUrl from "core/apiUrl"
const endpoints = {
  //courses
  coursesList: () => `${apiUrl}/v2/admin/courses/`,

  // lessons
  lessonList: () => `${apiUrl}/v2/admin/lessons/`,

  // disciples
  disciplesList: () => `${apiUrl}/v2/admin/disciples/`,

  // mailouts
  courseMailoutEmails: (id) =>
    `${apiUrl}/v2/admin/courses/${id}/mailout-emails/`,
  sendCourseMailout: (id) =>
    `${apiUrl}/v2/admin/courses/${id}/send-mailout/`,
  siteMailoutEmails: () => `${apiUrl}/v2/admin/site-mailouts/emails/`,
  sendSiteMailout: () => `${apiUrl}/v2/admin/site-mailouts/send-mailout/`,
  lessonMailoutEmails: (id) =>
    `${apiUrl}/v2/admin/lessons/${id}/mailout-emails/`,
  sendLessonMailout: (id) =>
    `${apiUrl}/v2/admin/lessons/${id}/send-mailout/`,
  sendMailout: () => `${apiUrl}/v2/admin/mailout/`,

  // participants
  participantCreation: () => `${apiUrl}/v2/admin/participants/`,
  participantList: () => `{apiUrl}/v2/admin/participants/`,
}

export default endpoints
